<div class="dialog-content">
  <ng-container *ngIf="data.type != 'flightUpdate' && data.type != 'bulkUpload'">
      <div class="preview_dailog_action_header" style="margin-top: 0.5em">
    <img [ngClass]="{
      'alert-vizibl-logo': !minVizLogo.has(data.type),
      'min-alert-vizibl-logo': minVizLogo.has(data.type)
    }" [src]="imgPath" />
  </div>
  <h3
    *ngIf="data.type !='audieceTargetingInstruction' && data.type != 'platformNotification'"
    class="alertMessage"
  >
    {{ popUpHeader }}
  </h3>
  <h3 *ngIf="data.type == 'platformNotification'" class="ms-3 me-2 active" [innerHTML]="data.notification['subject']"></h3>
  </ng-container>

   <h3 *ngIf="data.type=='emailComponent'">
      An email has been sent to <span class="active">{{data.email}}</span> with a link to reset your password.
   </h3>
   <h3 *ngIf="data.type=='cpaBiddingStrategy'">
    A Delivery Modifier cannot be associated to a Line Item (LI) when the bidding strategy is set to CPA.
    In this case, any existing Delivery Modifier will be automatically removed.
    If you revert to a previous bidding strategy, you will need to re-associate the Delivery Modifier to the LI.
   </h3>
   <div *ngIf="data.type=='validMacros'">
    <ng-container *ngFor="let key of objectKeys(data.validMacros)">
      <ng-container *ngIf="key !== 'all'">
        <div>
          <span class="field-name">{{ key === 'gdpr' ? 'GDPR Macros' : (key + ' Macros' | titlecase) }}:</span>
          <ng-container *ngFor="let item of data.validMacros[key]; let l = last">
            {{ !l ? item + ', ' : item + '.' }}
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </div>
   <h3 *ngIf="data.type=='Adtype-change-in-li'">
    Changing the Ad Type will remove creatives from this LI (copied from the old LI) and you have to associate new creatives of new ad type in this LI.
 </h3>
   <h3 *ngIf="data.type=='passwordComponent'">
      New password has been sucessfully updated.
   </h3>
   <h3 *ngIf="data.type=='reportGenerationPollMessage'">
    Your report is being generated. This may take a while. You can check the status of the report in Manage Reports section.
  </h3>
   <h3 *ngIf="data.type=='allContractsSigned'">
    Thank you for accepting all the pending amendments.
   </h3>
   <h4 *ngIf="data.type=='audieceTargetingInstruction'">
    <ol class="instruction">
      <li>Audiences can be grouped into different groups by clicking "Add New Group". Operator between groups is always an "AND"</li>
      <li>Audiences within group can be all Included or all Excluded</li>
      <li>Operator between Include audiences within Groups will always be "OR". Operator between exclude audiences within Groups will always be "AND"</li>
      <li>A max of 10 groups with Include and 1 group with Exclude are allowed</li>
    </ol>
  </h4>
   <h3 *ngIf="data.type=='instructionToSign'">
    You can also visit "My Profile" page to review and accept any pending amendments.
   </h3>
   <h3 *ngIf="data.type=='creativeselectedinsplits'">
    Creative {{data.item}} is associated with splits. Hence, it cannot be deassociated.
   </h3>
   <h3 *ngIf="data.type=='trackkerRestriction'">
    Create an event before associating with Convertion Trackers
   </h3>
   <h3 *ngIf="data.type=='totalBudgetLesser'">
    Please increase the total budget for the line item to include additional flight intervals.
  </h3>
   <h3 *ngIf="data.type=='signUp-success-msg'">
    Thank you for signing up on {{platformName}}.You will receive your sign-in credentials shortly.
    <ng-container *ngIf="data.optedNetflixInv">
      We also received your request to use Netflix inventories for running campaigns.
      Our team will review this request and get back to you.
    </ng-container>
   </h3>
   <h3 *ngIf="data.type=='multipleCreativeselectedinsplits'">
    <ng-container *ngIf="data.item.length==1">
      Creative {{data.item}} is associated with splits. Hence, it cannot be deassociated.
    </ng-container>
    <ng-container *ngIf="data.item.length>1">
      The following creatives
      <ng-container *ngFor="let item of data.item let l=last">
        <span class="creative-item">{{!l ? item+(", "): item}} </span>
      </ng-container>
      are associated with splits.Hence, they cannot be deassociated.
    </ng-container>
   </h3>

  <h3 *ngIf="data.type == 'removePixelMapping'">
    Deleting the universal pixel events will erase all collected data
    permanently. Do you want to proceed ?
  </h3>

  <h3 *ngIf="data.type == 'bdspPacingChange'">
    You are changing the pacing strategy from <b>{{ data.oldValue }}</b> to
    <b>{{ data.newValue }}</b
    >. Please confirm to proceed.
  </h3>

  <div *ngIf="data.type == 'tdspFlightUpdates'">
    <h3>What would you like to do?</h3>
    <div *ngIf="!data.enableUpdate">
      The existing flights for the selected Insertion Orders have ended and cannot be modified.
    </div>
    <mat-radio-group [(ngModel)]="tdspFlightUpdate">
      <mat-radio-button value="new">Create a new flight</mat-radio-button>
      <mat-radio-button [disabled]="!data.enableUpdate" value="update">Update an existing flight</mat-radio-button>
    </mat-radio-group>
  </div>

  <div class="platform-notification" *ngIf="data.type == 'platformNotification'">
    <p class="ms-3 me-2" [innerHTML]="data.notification['description']"></p>
  </div>

   <h3 *ngIf="data.type == 'campaignError'">
    The {{ data.entity }} cannot be updated because of the following errors:
    <table class="display-error">
      <thead class="active">
        <tr>
          <td>Name</td>
          <td>ID</td>
          <td>Error Description</td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data.items">
          <td>{{ item.name }}</td>
          <td>{{ item.id }}</td>
          <td>
            <ng-container *ngIf="isArray(item.error); else nonArray">
              <ul class="campaign-err-listing" *ngFor="let error of item.error">
                <li>{{ error }}</li>
              </ul>
            </ng-container>
            <ng-template #nonArray>
              {{item.error}}
            </ng-template>
          </td>
        </tr>
      </tbody>
    </table>
  </h3>

   <h3 *ngIf="data.type == 'campaignErrorTrgt'">
    The {{ data.entity }} cannot be updated because of the following errors:

    <table class="display-error">
      <thead class="active">
        <tr>
          <td>ID</td>
          <td>Error Description</td>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let item of data.items">
          <td>{{ item.id }}</td>

          <td>
            <ng-container *ngIf="item?.error?.error?.length; else nonArray">
              <ul class="campaign-err-listing">
                <li *ngFor="let err of item.error.error">
                  {{ err }}
                </li>
              </ul>
            </ng-container>

            <ng-template #nonArray>
              {{ item?.error }}
            </ng-template>
          </td>
        </tr>
      </tbody>
    </table>
  </h3>

  <h3 *ngIf="data.type == 'liFlightError'">
    The {{ data.entity }} cannot be updated because of the following errors:
    <table class="display-error">
      <thead class="active">
        <tr>
          <td>Flight ID</td>
          <td>Error Description</td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data.items">
          <td>{{ item.id }}</td>
          <td>
            <ng-container *ngIf="isArray(item.error); else nonArray">
              <ul class="campaign-err-listing" *ngFor="let error of item.error">
                <li>{{ error }}</li>
              </ul>
            </ng-container>
            <ng-template #nonArray>
              {{item.error}}
            </ng-template>
          </td>
        </tr>
      </tbody>
    </table>
  </h3>
  <h3 *ngIf="data.type == 'tdspIoFlightsUpdate'">
    {{data.error.error}}
    <table class="display-error">
      <thead class="active">
        <tr>
          <td>Name</td>
          <td>ID</td>
          <td>Error Description</td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data.error.error_details">
          <td>{{ item.name }}</td>
          <td>{{ item.id }}</td>
          <td>
            <ng-container *ngIf="isArray(item.errors); else nonArray">
              <ul class="campaign-err-listing" *ngFor="let error of item.errors">
                <li>{{ error }}</li>
              </ul>
            </ng-container>
            <ng-template #nonArray>
              {{item.errors}}
            </ng-template>
          </td>
        </tr>
      </tbody>
    </table>
  </h3>

  <div *ngIf="data.type == 'tdspIoPixelUpdates'">
    <p class="align-center" *ngFor="let item of data.error.error; let index=index">
       <span class="me-2">{{index+1}}</span> {{ item }}
    </p>
  </div>
  <h3 *ngIf="data.type == 'productFeedSyncHistory'">
    <ng-container *ngIf="data.items.length > 0; else emptyList">
      <div style="overflow-y: auto; width: 100%; height: 60vh;">
        <table class="display-error mt-3 scroll-table product-feed-table">
          <thead class="active">
            <tr>
              <td>S.No</td>
              <td>Product Feed Name</td>
              <td>Sync ID</td>
              <td>Sync Status</td>
              <td>Sync Error</td>
              <td>Synced At</td>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let item of data.items; let index = index"
              class="table-row-sync"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ data.name }}</td>
              <td>{{ item.id }}</td>
              <td>
                {{ item.sync_status }}
              </td>
              <td class="sync-error-desc">
                {{ item.sync_error ? item.sync_error : "-" }}
              </td>
              <td>
                {{ item.synced_at ? item.synced_at : "-" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
    <ng-template #emptyList>
      No Sync History to show
    </ng-template>
  </h3>

  <h3 *ngIf="data.type == 'crtvPkgImpactedLis'">
    Any updates to {{ data.crtvPkgName }} ({{ data.crtvPackageId }}) will impact
    the following LIs.
    <ng-container *ngIf="data.impactedLis.count > 0; else emptyList">
      <div style="overflow-y: auto; width: 100%; text-align: center">
        <table class="display-error scroll-table mt-2">
          <thead class="active">
            <tr>
              <td>S.No</td>
              <td>Name</td>
              <td>ID</td>
              <td>State</td>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let item of data.impactedLis.data; let index = index"
              class="table-row-sync"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.id }}</td>
              <td>{{ item.state }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
    <ng-template #emptyList> No Lis to show </ng-template>
  </h3>

   <h3 *ngIf="data.type == 'creativeFolder'">
    You have reached the maximum folders allowed. Please use existing folders or upgrade to the next tier
   </h3>
   <h3 *ngIf="data.type == 'creativeSegment'">
    A Maximum of 5 segments can be associated with a creative
   </h3>
   <h3 *ngIf="data.type == 'googleInventorySelected'">
    {{googleInventoryInfoMessage}}
  </h3>
  <h3
    *ngIf="data.type == 'countriesToTarget'"
    class="locationTargeting"
  >
    <ul>
      <li *ngFor="let country of countriesToTarget">
        {{country}}
      </li>
    </ul>
  </h3>
  <h3
    *ngIf="data.type == 'gamblingCtry'"
    class="locationTargeting"
  >
    <ul>
      <li *ngFor="let country of data.countries">
        {{country}}
      </li>
    </ul>
  </h3>
   <h3 *ngIf="data.type == 'adspILTargeting'">
    A Maximum of 10 Inventory lists can be associated with a line item.
   </h3>
   <h3 *ngIf="data.type == 'domainListLimit'">
    Total domain/url count exceeds 100.Maximum of 100 can be added.
   </h3>
   <h3 *ngIf="data.type == 'ipUploadLimit'">
    Total IP Address count exceeds 5000.Maximum of 5000 can be added.
   </h3>
   <h3 *ngIf="data.type == 'creativeSegment'">
    Advertiser is not yet activated.
   </h3>
   <h3 *ngIf="data.type == 'avgBudgetExceeds'">
    Daily budget set by you is more than the average daily budget for the
    following
    {{ data.avgDailyBgtExceeds.length > 1 ? "flights" : "flight" }} (Calculated
    as Flight Budget/Flight Duration). This may result in unintended results
    including overspends. Click OK to proceed to next step or Cancel to go back
    to the set up page to fix this issue
    <table class="flight_interval_table">
      <thead class="active">
        <tr>
          <td>Start Date</td>
          <td>End Date</td>
          <td>Flight Budget</td>
          <td>Current Daily Budget</td>
          <td>Suggested Daily Budget</td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let flight of data.avgDailyBgtExceeds">
          <td>{{ flight.start_date | date : "mediumDate" }}</td>
          <td>{{ flight.end_date | date : "mediumDate" }}</td>
          <td>{{ flight.revenue_budget | currency: data.clientCurrency}}</td>
          <td>{{ flight.daily_revenue_budget | currency: data.clientCurrency}}</td>
          <td>{{ flight.avg_daily_budget | currency: data.clientCurrency}}</td>
        </tr>
      </tbody>
    </table>
  </h3>
   <h3 *ngIf="data.type == 'desktopIvtConstraint'">
    Desktop cannot be unselected if you have selected one of Amazon & IMDb desktop site inventories.
  </h3>
  <h3 *ngIf="data.type == 'ctvDeviceMandatory'">
    Connected TV device is mandatory for CTV ads.
  </h3>
  <h3 *ngIf="data.type == 'duplicateLIMsg'">
    {{data.ioDealType ? 'Conversion Pixel(s) and': '' }}
    Creative(s) have to be associated afresh to this {{data.campaignType}}
  </h3>
  <h3 *ngIf="data.type=='offlineCommission'">
    Note if the commision type is changed the effective date can be only on the 1st of a month (immediate next month or future months).
 </h3>
   <ng-container *ngIf="data.type == 'pendingContract'">
    <h3>Below amendments have been made to your accepted terms and conditions. Please review and accept on or before the "Last date to accept" indicated in the table below
      to avoid {{platformName}} account access issues. In case of any queries, please reach out to your account manager and/or send a mail to <a class="mail-link" href="mailto:{{supportEmail}}">{{supportEmail}}</a>
    </h3>
    <table class="mt-3" mat-table [dataSource]="contractHistoryDataSource" #contractHistorySort='matSort' matSort style="width: 100%">
      <ng-container matColumnDef="serial_number">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="table_header_name">S.No</span>
        </th>
        <td mat-cell *matCellDef="let row; let i=index">
          <span class="table_value_name"> {{ row.serial_number }} </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="table_header_name">Document Name</span>
        </th>
        <td mat-cell *matCellDef="let row">
          <span class="table_value_name contract-name">
            <a (click)="viewFile(row.msa_contract_id, row.name, row.description, row.msa_status=='pending')">
              {{ row.name }}
            </a>
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="table_header_name">Description
            <span matTooltip="Document description" matTooltipClass="tooltip-class"
              class="material-icons tool-tip">
              error
            </span>
          </span>
        </th>
        <td mat-cell *matCellDef="let row">
          <span class="table_value_name" [title]="row.description.length > 15 ? row.description: ''" [ngStyle]="{'cursor': (row.description.length>15)?'pointer':''}"> {{ (row.description.length <15 ? row.description : row.description.slice(0, 15) + "..." ) || "_" }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="last_date_to_accept">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="table_header_name">Last date to accept</span>
        </th>
        <td mat-cell *matCellDef="let row">
          <span class="table_value_name"> {{ row.last_date_to_accept ? (row.last_date_to_accept.split(" ")[0] | date) : "_" }}</span>
        </td>
      </ng-container>


      <ng-container matColumnDef="upload_date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="table_header_name">Upload Date</span>
        </th>
        <td mat-cell *matCellDef="let row">
          <span class="table_value_name"> {{ row.upload_date.split(" ")[0] | date }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="msa_type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="table_header_name"> Doc Type</span>
        </th>
        <td mat-cell *matCellDef="let row">
          <span class="custom-chip">
            <span class="custom-chip-content ">
              {{ row.msa_type.split("_").join(" ") | titlecase }}
            </span>
          </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedContractColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedContractColumns"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="13">No data available</td>
      </tr>
    </table>
    <mat-paginator #contractHistoryPaginator [pageSizeOptions]="[10, 15, 25, 100]"
      [length]="pageLength"></mat-paginator>
    </ng-container>
   <div *ngIf="data.type=='clientContent'">
      <h3 *ngIf="data.adminState != 'active'" [ngClass]="{'ms-1': data.adminState=='paused'}">
         {{data.client.split("_").join(" ") | titlecase}} is in {{data.adminState}} state. Please contact platform administrator
      </h3>
      <h3 *ngIf="data.accountState == 'inactive'&& data.adminState == 'active'">
          {{data.client.split("_").join(" ") | titlecase}} is deactivated and is in read-only mode. Please add more funds to activate or contact your
          account manager.
      </h3>
      <h3 *ngIf="data.advertiserState != 'active'&& data.adminState == 'active'&& data.accountState == 'active'">
        You cannot perform this function as this agency advertiser has been deactivated
      </h3>
      <h3
         *ngIf="data.clientType == 'self'&& data.adminState == 'active'&& data.accountState == 'active'&&(data.advertiserState=='active'||data.advertiserState == '')">
        You cannot perform this function for a self service client. Please contact your account manager
      </h3>
      <h3
         *ngIf="data.clientType == 'managed'&& data.adminState == 'active'&& data.accountState == 'active'&&(data.advertiserState=='active'||data.advertiserState == '')">
        You cannot perform this function as a managed service client. Please contact your account manager
      </h3>
   </div>
   <h3 *ngIf="data.type=='adspModel'">
    Your advertiser is not yet activated. Please wait for the activation or reach out to {{platformName}} support team
   </h3>

   <div class="table-desc mb-3" *ngIf="data.type == 'conTrksError'">
    <p>
      Event/Product tracker asscociation failed for the below ids.Kindly edit
      the Insertion Order and review the associated Event/Product tracker.
      For reference, you can click on the download button.
    </p>
    <table class="pop_up_table">
      <tr>
        <th>Type</th>
        <th>ID</th>
        <th>Reason</th>
      </tr>
      <tbody>
        <tr *ngFor="let item of data.ct_err">
          <td>{{ item.type | titlecase }}</td>
          <td>{{ item.id }}</td>
          <td>{{ item.reason }}</td>
        </tr>
      </tbody>
    </table>
    <button mat-button class="create-btn mt-2 float-end" (click)="download()">Download</button>
  </div>

  <ng-container *ngIf="data.type == 'postalCodeValidation'">
    <ng-container *ngIf="data.inactivePostalCodes.length">
      <div class="field-name">Inactive Postal Codes</div>
      <p class="table-desc">
        We have noticed some inactive postal codes these have very limited geo-targeting data but are
        available for targeting.
      </p>
      <p><b>Postal Codes:</b> {{ data.inactivePostalCodes.join(", ") }}</p>
    </ng-container>

    <mat-divider
      class="mt-1 mb-1"
      *ngIf="data.inactivePostalCodes.length && data.invalidPostalCodes.length"
    ></mat-divider>

    <ng-container *ngIf="data.invalidPostalCodes.length">
      <div class="field-name">Invalid Postal Codes</div>
      <p class="table-desc">
        We have noticed some invalid postal codes and these are invalid and not available for targeting.
      </p>
      <p><b>Postal Codes:</b> {{ data.invalidPostalCodes.join(", ") }}</p>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="data.type == 'tdspInvalidDomain'">
    <ng-container *ngIf="data.inValidDomainAppurls.length">
      <div class="field-name">Invalid Doamain/APP URLs</div>
      <p class="table-desc">
        We have noticed some invalid Domain/APP URLs and these are invalid and not available for targeting.
      </p>
      <p><b>Domain/APP URLs:</b> {{ data.inValidDomainAppurls.join(", ") }}</p>
    </ng-container>
  </ng-container>

   <div class="kpi-suggestion" *ngIf="data.type == 'kpiSuggestion'">
    <p><b>Suggested Min KPI value</b>: {{ data.minValue }}</p>
    <p><b>Suggested Max KPI value</b>: {{ data.maxValue }}</p>

    <span
    ><b>Note:</b> The Target KPI recommendation is based on the IO goal KPI
      <span class="active">{{
        data.ioSummary.goal_kpi.split("_").join(" ") | titlecase
      }}</span>
      at the cumulative budget of
      <span class="active">{{ data.ioSummary.budget | currency: data.currency }}</span> during the time
      period
      <span class="active"
        >{{ data.ioSummary.start_date }} to {{ data.ioSummary.end_date }}.</span
      >This is only a recommendation for optimal performance.</span
    >
    </div>

    <div class="table-desc" *ngIf="data.type == 'dlvModifierEditMsg'">
      <p>The delivery modifier <span class="bold">{{data.name}} ({{data.id}})</span> is associated to the following Line items.</p>
      <table class="pop_up_table">
        <tr>
          <th>S.NO</th>
          <th>Line Item</th>
          <th>Insertion Order</th>
        </tr>
        <tbody>
          <tr *ngFor="let li of data.liAssocData let index=index">
            <td>{{ index+1 }}</td>
            <td>{{ li.name }} ({{li.id}})</td>
            <td>{{ li.io_name }} ({{li.io_id}})</td>
          </tr>
        </tbody>
      </table>
    </div>

  <div class="flight-update" *ngIf="data.type == 'flightUpdate'">
    <h2>
      {{ data.entityType.split("_").join(" ") | titlecase }}: Flights Bulk
      Update
    </h2>
    <div>
      <span class="warning_message">
        <ol>
          <li>  {{ data.entityType.split("_").join(" ") | titlecase }} with a PG deal type
            is not eligible for bulk flight updates.
          </li>
          <li> Kindly download the template file and follow the
            instructions to make the required changes.
                      <ol>
            <li>
            <a
            class="cursor_pointer hyperlink"
            (click)="getTemplate('multiple')"
            >Click here</a
          >
          to download template for selected
          {{ data.entityType.split("_").join(" ") }}(s) related to flight updates.
            </li>
            <li>
              <a class="cursor_pointer hyperlink" (click)="getTemplate('single')"
            >Click here</a
          >
          to download template for all {{ data.entityType.split("_").join(" ") }} items related flight updates.
            </li>
          </ol>
          </li>
        </ol>
      </span>
    </div>
    <span class="material-icons upload_action me-2 mt-4"> ios_share </span>
    <button
      mat-button
      class="action_btn_no-border mt-1"
      (click)="fileInput.click()"
    >
      UPLOAD FILE
    </button>
    <input
      (change)="onSelectFile($event)"
      hidden
      #fileInput
      type="file"
      id="file"
      (click)="$event.target.value = null"
    />
    <span
      *ngIf="fileUploaded"
      class="material-icons check_button mt-2"
      [style]="'color: green;'"
    >
      check_circle
    </span>
    <div class="mt-3 error-message">
      <ng-container *ngIf="errorOccured">
        {{errorMSG}}. <a class="cursor_pointer hyperlink" href="{{errorURL}}" target="_blank">Click here</a> to know more.
      </ng-container>
    </div>
  </div>

    <ng-container *ngIf="data.type == 'ioGoalChange'">
    <p>
      The following line items are currently linked to the goal {{ data.goal }}:
    </p>

    <table class="pop_up_table">
      <tr>
        <th>S.NO</th>
        <th>Line Item ID</th>
        <th>Line Item Name</th>
      </tr>

      <tbody>
        <tr *ngFor="let li of data.items; let index = index">
          <td>{{ index + 1 }}</td>
          <td>{{ li.name }}</td>
          <td>({{ li.id }})</td>
        </tr>
      </tbody>
    </table>

    <p>
      Removing this goal will deactivate the associated line items. To reactivate them, you must select a new goal.
      If you do not wish to proceed, please reselect the current goal.
    </p>
  </ng-container>

  <div class="table-desc" *ngIf="data.type == 'removeTdspIoFlight' || data.type == 'expiredLi' || data.type == 'expiredIO'">
    <p>
    {{
      data.type === 'removeTdspIoFlight'
        ? 'Deleting the flights from this IO will also delete them from the following LIs.'
        : 'The following ' + (data.type === 'expiredLi' ? 'LI' : 'IO') + ' have been expired and cannot be updated.'
    }}
  </p>
    <table class="pop_up_table">
      <tr>
        <th>S.NO</th>
        <th>{{data.type == 'expiredIO' ? 'Insertion Order ID' : 'Line Item ID'}}</th>
        <th>{{data.type == 'expiredIO' ? 'Insertion Order Name' : 'Line Item Name'}}</th>
      </tr>

      <tbody>
        <tr *ngFor="let li of data.lineItems; let index = index">
          <td>{{ index + 1 }}</td>
          <td>{{ li.name }}</td>
          <td>({{ li.id }})</td>
        </tr>
      </tbody>
    </table>

    <p>
      Are you sure you want to proceed?
    </p>
  </div>

    <div class="flight-update" *ngIf="data.type == 'bulkUpload'">
    <h2>
      {{ data.entityType.split("_").join(" ") | titlecase }}: Bulk
      Upload
    </h2>
    <div>
      <span class="warning_message">
        <p>
          Kindly <a class="cursor_pointer hyperlink" (click)="getBulkUploadTemplate()">download</a>
          the template file and follow the instructions to make the required changes.
        </p>
      </span>
    </div>
    <span class="material-icons upload_action me-2 mt-4"> ios_share </span>
    <button
      mat-button
      class="action_btn_no-border mt-1"
      (click)="fileInput.click()"
    >
      UPLOAD FILE
    </button>
    <input
      (change)="onSelectFile($event)"
      hidden
      #fileInput
      type="file"
      id="file"
      (click)="$event.target.value = null"
    />
    <span
      *ngIf="fileUploaded"
      class="material-icons check_button mt-2"
      [style]="'color: green;'"
    >
      check_circle
    </span>
    <div class="mt-3 error-message">
      <ng-container *ngIf="errorOccured">
        {{errorMSG}}. <a class="cursor_pointer hyperlink" href="{{errorURL}}" target="_blank">Click here</a> to know more.
      </ng-container>
    </div>
  </div>

   <div class="preview_dailog_action_buttons mt-2 mb-1">
    <div class="table_action_cell" *ngIf="showCancelBtn.has(data.type)">
      <button mat-button class="action_btn_no-border" (click)="closeModel(false)">
        Cancel
      </button>
    </div>
      <div class="table_action_cell">
        <button *ngIf="!data.overdue" mat-button class="action_btn_no-border" (click)="confirmAction()">
          {{
            showSnoozeBtn.has(data.type)
              ? "Snooze"
              : showSaveBtn.has(data.type)
              ? "Save"
              : showProceedBtn.has(data.type)
              ? "Proceed"
              : "Ok"
          }}
        </button>
      </div>
   </div>

</div>
